import axios from 'axios'
import { Message } from 'element-ui'

import config from './config'
import qs from 'qs'
import {getCookie} from '@/utils'

axios.defaults.timeout = config.timeout // 响应时间
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/requestApi/' : config.baseUrl // 配置接口地址

let token = ''
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((conf) => {
    if (token) {
        // conf.headers['token'] = token
        conf.headers['vatlogintoken'] = token //这里写上cookie
    }

    // document.cookie =` com.gooagoo.passpart.sso.token.name=misUser1HATOQI3UFUK627QG15S92AIR90015F2; user_token=misUser1HATOQI3UFUK627QG15S92AIR90015F2`

    if(conf.isFile){
        // conf.responseType = 'blob';
        if(conf.isVideo){
            console.log('isVideo')
            conf.headers['Content-Type'] = 'video/mp4';

        }else{
            conf.headers['Content-Type'] = 'multipart/form-data';

        }

    }else if(conf.isJson){
        // conf.data = conf.data
    }else{
        conf.data = qs.stringify(conf.data)
    }



    return conf
}, (error) => {
    // Toast.fail(error)
    return Promise.reject(error)
})

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    getCookie('com.gooagoo.passpart.sso.token.name');
    if (res.data.status === 'S') {
        return Promise.resolve(res.data.data)
    }
        // else if (res.data.status === "F") {
        // }else if(res.data.status === 'sucess'){ // 获取 openid
        //     store.commit('mloading/hideLoading')
        //     return Promise.resolve(res.data)
    // }
    else {
        // console.log(res)
        // if (res.data.status == 'F') {
        //     Message.error(res.data.msg)
        //     if (res.data.msg == '用户未登录') {
        //         window.location.href = 'https://passport.gooagoo.com/index.html'
        //     }
        // }
        // if (res.data.status == 'T') {
        //
        //         window.location.href = 'https://passport.gooagoo.com/index.html'
        //
        // }

        return Promise.reject(res)
    }
}, (error) => {
    // store.commit('mloading/hideLoading')
    // Toast.fail('糟糕飞走了' + error)
    return Promise.reject(error)
})

export function fetchPost(url, params, options = {}) {
    return new Promise((resolve, reject) => {
        let baseUrl=''
        if(options&&options.otherUrl){
            // axios.defaults.baseURL=options.loginUlr
            baseUrl=options.otherUrl + url
        }else{
            baseUrl=url
        }
        axios.post(baseUrl, params, options)
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function fetchPut(url, params, options = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, params, options)
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function fetchGet(url, param,options) {
    return new Promise((resolve, reject) => {
        let baseUrl=''
        if(options&&options.otherUrl){
            // axios.defaults.baseURL=options.loginUlr
            baseUrl=options.otherUrl + url
        }else{
            baseUrl=url
        }


        axios.get( baseUrl  , {params: param})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function fetchDelete(url, param) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {params: param})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export default axios.create()
